<template>
    <div class="form-group ">
        <label :for="name" v-if="!hideLabel">{{label}}</label>
        <input type="text"
               :placeholder="placeholder"
               v-validate="validate"
               :value="value"
               :id="name"
               :name="name"
               :data-vv-as="label"
               @input="inputValue"
               class="form-control"
               :class="{'is-invalid':errors.has(name)}"/>
        <div v-if="errors.has(name)" class="invalid-feedback">
            {{errors.first(name)}}
        </div>
    </div>
</template>

<script>
    import mixinField from '../../mixins/mixinField';

    export default {
        mixins: [mixinField],
        name: "FieldEmail",
        data() {
            return {
                rules:"email"
            }
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/fields/FieldEmail.vue